import { RouteComponentProps } from "@reach/router";
import React, { useState } from "react";
import styled from "styled-components";
import Grid from "../components/VideoGrid";
import { getLocalPosition } from "../utils/arrange-players";
import { Wrapper } from "./Wrapper";

const TestGridElement = styled.div``;
const TestContent = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  padding: 5px;
  align-items: var(--overlay-align, flex-start);
  justify-content: var(--overlay-justify, flex-end);
`;
const TestSelect = styled.select`
  position: absolute;
  bottom: 5px;
  right: 5px;
`;

type Props = RouteComponentProps;
const TestGrid: React.FC<Props> = () => {
  const [num, setNum] = useState(8);
  const localPos = getLocalPosition(num);
  return (
    <>
      <Wrapper>
        <TestGridElement>
          <Grid>
            {Array.from({ length: num }).map((_, i) => (
              <TestContent
                key={i}
                style={{
                  backgroundColor: localPos === i ? "red" : "transparent"
                }}
              >
                <span>p{i + 1}</span>
              </TestContent>
            ))}
          </Grid>
        </TestGridElement>
        <TestSelect
          value={num}
          onChange={(e) => {
            setNum(parseInt(e.target.value, 10));
          }}
        >
          {Array.from({ length: 8 }).map((_, i) => (
            <option key={i} value={i + 1}>
              {i + 1}
            </option>
          ))}
        </TestSelect>
      </Wrapper>
    </>
  );
};

export default TestGrid;
